import AxiosCustom from "../../../common/components/apiConfig";

export const send_payment_request = (data) => {
	let config = { url: "insert_request" };

	let _data = {
		table: "payment",
		method_type: "send_payment_request",
		data: {
			...data,
		},
	};

	return AxiosCustom(config, _data);
};
